var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHamburgerGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_298",
    "data-name": "Group 298",
    transform: "translate(-542.121 -3407.445)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_361",
    "data-name": "Rectangle 361",
    width: 18,
    height: 2,
    rx: 1,
    transform: "translate(542.121 3407.445)",
    fill: "#98a1a9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_361-2",
    "data-name": "Rectangle 361",
    width: 18,
    height: 2,
    rx: 1,
    transform: "translate(542.121 3412.445)",
    fill: "#98a1a9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_361-3",
    "data-name": "Rectangle 361",
    width: 18,
    height: 2,
    rx: 1,
    transform: "translate(542.121 3417.445)",
    fill: "#98a1a9"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerGray);
export default __webpack_public_path__ + "static/media/hamburgerGray.0b1f825ca7f403556a59bf635d85db65.svg";
export { ForwardRef as ReactComponent };